import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';

export const ReachYourGoalComponent = () => {
  const reachYourGoal = [
    {
      icon: '🍽️',
      title: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.recipesTitle'),
      description: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.recipesDesc'),
    },
    {
      icon: '📸',
      title: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.nutritionScoreTitle'),
      description: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.nutritionScoreDesc'),
    },
    {
      icon: '💬',
      title: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.chatTitle'),
      description: t('onboarding.personalPlanGraphWithVideo.reachYourGoal.chatDesc'),
    },
  ];

  return (
    <>
      <Title tag='h4' className={styles.listTitle}>
        {t('onboarding.personalPlanGraphWithVideo.howHelp')}
        <span> {t('onboarding.personalPlanGraphWithVideo.reachGoal')}</span>
      </Title>
      <div className={styles.reachYourGoal}>
        {reachYourGoal.map((item, index) => (
          <div className={styles.reachYourGoalItem} key={index}>
            <Text>{item.icon}</Text>
            <div>
              <Text semibold>{item.title}</Text>
              <span>{item.description}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
